import React from "react";
import { ArrowRightOutlined } from "@ant-design/icons";
import { ROLES, STAGES } from "components/common/Constants";
import { getFormalName, getNextStage } from "components/services";
import { ButtonContainer, StyledButton } from "./CardsTableStyles";

// Check if Forward button should be shown based on user role and current stage
const shouldShowForward = (user, record) => {
	// ADMIN and DESIGN can see Forward for all stages
	if ([ROLES.ADMIN, ROLES.DESIGN].includes(user.roll)) {
		return true;
	}
	// Other roles can only see Forward when current stage matches their role
	const roleStageMap = {
		[ROLES.CUTTING]: STAGES.CUTTING,
		[ROLES.SAMPLING_DIGITIZER]: STAGES.SAMPLING_DIGITIZER,
		[ROLES.SECONDARY_PROCESS]: STAGES.SECONDARY_PROCESS,
		[ROLES.EMBROIDARY]: STAGES.EMBROIDARY,
		[ROLES.PRODUCTION]: STAGES.PRODUCTION,
		[ROLES.PACKING]: STAGES.PACKING,
		[ROLES.ACCOUNT]: STAGES.ACCOUNT,
		[ROLES.PAYMENT]: STAGES.PAYMENT,
		[ROLES.DISPATCH]: STAGES.DISPATCH,
	};
	return roleStageMap[user.roll] === record.current_stage;
};

// Check if Forward button should be disabled
const isForwardDisabled = (user, record) => {
	return (
		record.current_stage === STAGES.COMPLETED ||
		(record.current_stage !== STAGES.CREATION && user.roll === ROLES.DESIGN)
	);
};

// Get the button label
const getForwardLabel = (record) => {
	if (record.current_stage === STAGES.COMPLETED) {
		return "Completed";
	}
	const needsDigitizerAssignment = record.current_stage === STAGES.CREATION &&
		(record.is_degitizer_stage === true || record.is_degitizer_stage === 'true') &&
		(!record.assigned_digitizers || record.assigned_digitizers.length === 0);
	if (needsDigitizerAssignment) {
		return "Assign Digitizer";
	}
	const prefix = record.current_stage === STAGES.DISPATCH ? "Mark as" : "";
	const nextStageName = getFormalName(getNextStage(record.current_stage));
	return `${prefix} ${nextStageName}`.trim();
};

const ForwardButton = ({ record, user, onForward }) => {
	if (!shouldShowForward(user, record)) {
		return null;
	}

	return (
		<ButtonContainer>
			<StyledButton
				icon={<ArrowRightOutlined />}
				size="large"
				onClick={(e) => {
					e.stopPropagation();
					onForward(record);
				}}
				disabled={isForwardDisabled(user, record)}
			>
				{getForwardLabel(record)}
			</StyledButton>
		</ButtonContainer>
	);
};

// Get the forward column configuration
export const getForwardColumn = ({ user, onForward }) => ({
	title: "Forward",
	key: "forward",
	align: "center",
	render: (_, record) => (
		<ForwardButton record={record} user={user} onForward={onForward} />
	),
});

export default ForwardButton;
